import React from 'react';
import { 
  Header, 
  Footer, 
  Hero, 
  Features, 
  Testimonials, 
  CTA 
} from '../components/guest';

const Landing = () => {
  return (
    <div style={{ background: '#fff' }}>
      <Header />
      <Hero />
      <Features />
      <Testimonials />
      <CTA />
      <Footer />
    </div>
  );
};

export default Landing;